<template>
  <div id="app">
    <div class="m-auto px-4 pt-10 pb-5 mb-5 max-w-5xl w-full border-b flex flex-row items-end justify-around">
      <a href="/">
        <img width="200" src="@/assets/Logo_transparente.gif" />
      </a>

      <div class="hidden  sm:block h-full w-full text-right items-end text-gray-700 text-sm"><a href="/">Volver al inicio</a></div>
    </div>

    <div class="pb-10 flex flex-col items-center ">        
      <Filtros @cambio="cambioFiltro($event)" 
        :sorter="sorter" 
        :sort="sortSelected" 
        :precios="precios" 
        :areas="areas"
        :prMax="prmaxSelected" 
        :prMin="prminSelected"
        :arMax="armaxSelected" 
        :arMin="arminSelected"
         />
      <Listado ref="listado" :sortType="sorter[sortSelected]" />
    </div>
    <Footer />
  </div>
</template>

<script>
import Listado from "./components/Listado.vue";
import Filtros from "./components/Filtros.vue";
import Footer from "./components/Footer.vue";
import "./assets/styles.css";
import "./assets/tailwind.min.css";


export default {
  name: "App",
  components: {
    Listado,
    Filtros,
    Footer
  },
  data() {
    return {
      sortSelected: 0,
      prminSelected: -1,
      prmaxSelected: -2,
      arminSelected: -1,
      armaxSelected: -2,      
      precios: [],  
      areas:[],
      sorter: [{ type: 'creation_date_desc', label: 'Los más recientes'} , 
      { type: 'creation_date_asc', label: 'Los más antiguos' },{
        type: 'price_desc', label: 'Los precios más altos'} , 
        { type: 'price_asc', label: 'Los precions más bajos'}],
    }
  }
  ,created() {
    this.sortSelected = 0
    for (let i=1; i<20;i++) {
      this.precios.push({type:(i* 50),label: (i* 50).toString()})
    }
    for (let i=1; i<15;i++) {
      this.precios.push({type:(i* 1000),label: (i* 1000).toString()})
    }
    for (let i=1; i<10;i++) {
      this.precios.push({type:(i* 10000)+5000,label: (i* 10000+5000).toString()})
    }        
    [30,40,50,60,70,80,90,100,150,200,300,400,500,750,1000,1500,3000,5000,10000,100000].forEach(i => {
      this.areas.push({type:i,label: (i.toString()+' m²')})
    });
  },
  methods: {
    cambioFiltro(filtro) { 
      this.sortSelected = filtro.sort
      if (this.$refs['listado'] !== undefined) {
        const listado = this.$refs['listado'];

        const sort = this.sorter[this.sortSelected].type;
        const min = filtro.prmin;
        const max = filtro.prmax;
        const armin = filtro.armin;
        const armax = filtro.armax;
        
        listado.recargar(sort,min,max,armin,armax);
      }
    }
  }
};
</script>
<style>

@keyframes spinner {
  to {transform: rotate(360deg);}
}
 
.spinner:before {
  content: '';
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 20px;
  margin-top: -10px;
  margin-left: -10px;
  border-radius: 50%;
  border: 2px solid #ccc;
  border-top-color: #000;
  animation: spinner .6s linear infinite;
}
</style>